import React from "react";
import { GraduationCap, Laptop, Award, ShieldCheck, Zap, FileCheck } from "lucide-react";
import { partners } from "../data/mock";

const iconMap = { GraduationCap, Laptop, Award, ShieldCheck, Zap, FileCheck };

const Partners = () => {
  return (
    <section className="py-12 bg-white border-y border-emerald-100">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-brand-dark/50 font-semibold mb-8">
          Riconoscimenti e accreditamenti
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center">
          {partners.map((p) => {
            const Icon = iconMap[p.icon] || Award;
            return (
              <div key={p.name} className="flex flex-col items-center text-center group">
                <div className="w-14 h-14 rounded-2xl bg-brand-light text-brand flex items-center justify-center mb-2 group-hover:bg-brand group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <div className="font-display font-bold text-brand-dark text-sm">{p.name}</div>
                <div className="text-[11px] text-brand-dark/60 uppercase tracking-wide">{p.subtitle}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Partners;
